import React from "react";
import { Spinner } from "react-bootstrap";

export default function Loader() {
  return (
    <div className="text-center mt-2">
      <Spinner animation="border" variant="primary" />
    </div>
  );
}
